






























import { Vue, Component, Prop } from 'vue-property-decorator';

import i18n from '@/plugins/i18n';

@Component
export default class KoinInstallmentSelect extends Vue {
  @Prop()
  private details: any;

  private panel = null;

  private get moreDetails() {
    return (this.panel === null || this.panel === undefined) ? 'Mais detalhes' : 'Menos detalhes';
  }

  private get detailsInstallmentsLabel() {
    return this.details && `${this.details.number} parcelas de ${i18n.n(this.details.amount, 'currency', 'pt-br')}`;
  }

  private get feeDetails() {
    let feeDetails = [];

    if (this.details) {
      feeDetails.push({
        text: 'Valor parcelado',
        value: `${i18n.n(this.details.original_value, 'currency', 'pt-br')}`,
      });

      feeDetails.push({
        text: 'Juros ao mês',
        value: this.convertToPercent(this.details.interest_per_month),
      });

      feeDetails.push({
        text: 'CET ao mês',
        value: this.convertToPercent(this.details.cet_per_month),
      });

      feeDetails.push({
        text: 'Total com Koin',
        value: `${i18n.n(this.details.order_value, 'currency', 'pt-br')}`,
      });
    }

    return feeDetails;
  }

  private convertToPercent(amount: number) {
    return amount === 0 ? `${i18n.n(amount, 'percent', 'pt-br')}` : `${i18n.n(amount / 100, 'percent', 'pt-br')}`;
  }
}
